import { getPageUrl } from '@/helpers/breadcrumbs'
import { populated } from '@/helpers/populated'
import { transformImage } from '@/helpers/transforms'
import type { TopicCardsBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import type { TopicCardCTAType } from '../atoms/TopicCardCTA'
import { TopicsBlock } from '../blocks/TopicsBlock'

export const TopicCardsConverter: JSXConverter<SerializedBlockNode<TopicCardsBlock>> = ({
	node,
}) => {
	const { topics } = node.fields

	const topicsData: TopicCardCTAType[] = []

	if (!topics) {
		return null
	}

	for (const topic of topics) {
		const { image, page, title, cta } = topic

		const imageData = transformImage(image)

		const link = populated(page) ? getPageUrl(page) : ''

		const topicData: TopicCardCTAType = {
			image: imageData,
			title: title,
			description: cta,
			href: link,
		}

		topicsData.push(topicData)
	}

	return <TopicsBlock topics={topicsData} />
}
